import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DashboardItemComponent } from '../../../components/iterables/dashboard-item/dashboard-item.component';
import { NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular-material-components/moment-adapter';
import { CustomDateAdapter } from '../../../shared/custom-date-adapter';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { DateTimePickerComponent } from '../../../components/formio/datetime-picker/datetime-picker.component';
import { NgxSpinnerModule } from 'ngx-spinner';

export const IMPORTS = [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    NgxMatDatetimePickerModule,
    MatDatepickerModule,
    NgxChartsModule,
    MatIconModule,
    DashboardItemComponent,
    SelectDropDownModule,
    DateTimePickerComponent
];

export const PROVIDERS = [
    {
        provide: NGX_MAT_DATE_FORMATS,
        useValue: {
            parse: {
                dateInput: "DD/MM/YYYY, [às] HH:mm:ss"
            },
            display: {
                dateInput: "DD/MM/YYYY, [às] HH:mm:ss",
                monthYearLabel: "MMM YYYY",
                dateA11yLabel: "LLL",
                monthYearA11yLabel: "MMMM YYYY"
            }
        }
    },
    { provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
];
